import * as React from 'react';
import * as classnames from 'classnames';
import {
    ConditionRule as IConditionRule,
    QuestionID
} from '@nexxt/common/types';
import { IRuleError } from '../../../../../interface/conditions.interface';
import { QuestionSummary } from '@nexxt/common/types';
import IncaVariableEvalEditor from '../../../../common/IncaVariable/IncaVariableEvalEditor';

interface ConditionRuleProps {
    isEdit: boolean;
    isConditionEdit: boolean;
    index: number;
    type: 'IPreCondition' | 'postcondition';
    questionSummaries: QuestionSummary[];
    rule: IConditionRule;
    errorObject: Partial<IRuleError>;
    editEnabled: boolean;
    currentQuestionId: QuestionID;
    onQuestionSelect: (question: any) => void;
    onAnswerTypeSelect: (answerType: any) => void;
    onValueChange: (type, value, options) => void;
    onEditRule: () => void;
    onSaveRule: () => void;
    onDeleteRule: () => void;
    onCancelAddRule: () => void;
}

interface ConditionRuleStates {
    isLoading: boolean;
    showError: boolean;
}

/**
 * This component provides UI for researcher to create a ConditionRule.
 * @NOTE: this component name collides with the ConditionRule object interface, should rename!
 */
class ConditionRule extends React.Component<
    ConditionRuleProps,
    ConditionRuleStates
> {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            showError: this.props.rule?.ruleID ? true : false
        };
    }

    /**
     * Set default destination question to the current question
     */
    componentDidMount(): void {
        if (
            this.props.type === 'postcondition' &&
            !this.props.rule?.selectedReferenceQ?.value &&
            this.props.rule.new &&
            this.props.currentQuestionId
        ) {
            const currentQuestion = this.props.questionSummaries.find(
                (questionSummary) =>
                    questionSummary.id == this.props.currentQuestionId
            );

            currentQuestion && this.props.onQuestionSelect(currentQuestion);
        }
    }
    onSaveRule = (): void => {
        const conditionError = this.props.errorObject || {};
        this.setState({ showError: true });

        if (conditionError && conditionError?.isError) {
            return;
        }
        this.props.onSaveRule();
    };

    render() {
        const {
            type,
            isEdit,
            isConditionEdit,
            rule,
            editEnabled,
            questionSummaries,
            onQuestionSelect,
            onAnswerTypeSelect,
            onValueChange,
            onCancelAddRule,
            onEditRule,
            onDeleteRule
        } = this.props;

        return (
            <div
                className={classnames('', {
                    rule: isEdit && isConditionEdit,
                    rule__created: !(isEdit && isConditionEdit)
                })}
            >
                <IncaVariableEvalEditor
                    isEdit={isEdit && isConditionEdit}
                    rule={rule}
                    disabled={!editEnabled}
                    questionSummaries={questionSummaries}
                    handleQuestionSelect={onQuestionSelect}
                    handleVariableFunctionSelect={onAnswerTypeSelect}
                    handleOptionSelect={onValueChange}
                />
                {isEdit && isConditionEdit ? (
                    <div className="btn-wrapper no-bg">
                        <button
                            className="btn btn--sm btn--transparent"
                            onClick={onCancelAddRule}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn btn--sm btn--green"
                            onClick={this.onSaveRule}
                            disabled={!editEnabled}
                        >
                            Add rule
                        </button>
                    </div>
                ) : type && isConditionEdit && editEnabled ? (
                    <ul className="rule-actions">
                        <li className="rule-actions__item">
                            <a onClick={onEditRule}>Edit Rule</a>
                        </li>
                        <li className="rule-actions__item">
                            <a onClick={onDeleteRule}>Delete Rule</a>
                        </li>
                    </ul>
                ) : null}
            </div>
        );
    }
}

export default ConditionRule;
